module.exports = "/_next/static/images/product-hunt-l@2x-0f1bfb946373b768b8dc7c470cfacf2a.png";